import React, { useState, useEffect } from "react";
import { observable, action } from "mobx";
import { observer } from "mobx-react";
import AutoCompleteDropdown from "Components/common/AutoCompleteDropdown";
import { TagPopupButtons } from "Components/common/tags/TagPopupButtons";
import { accountsState } from "../AccountsState";
import {
  AccountListBody,
  CreateNewAccountList,
  CreateEditAccountListPopup
} from "../AccountListDropdown";
import "./organizeAccountsPopup.scss";

class OrganizeAccountsPopupState {
  @observable showPopup = false;
  @observable popupValues = {};

  @action
  setShowPopup = val => {
    this.showPopup = val;
    if (!val) {
      this.popupValues = {};
    }
  };

  @action
  setPopupValues = values => {
    this.popupValues = values;
  };
}

const organizeAccountsPopupState = new OrganizeAccountsPopupState();

const OrganizeAccountsPopup = observer(() => {
  const [selectedList, setSelectedList] = useState(null);
  const [showListDropdown, setShowListDropdown] = useState(false);
  const [showCreatePopup, setShowCreatePopup] = useState(false);

  const closeAction = () => {
    setSelectedList(null);
    setShowListDropdown(false);
    organizeAccountsPopupState.setShowPopup(false);
  };

  const confirmAction = () => {
    const { cbk } = organizeAccountsPopupState.popupValues;
    cbk && cbk(selectedList?.id || null);
    closeAction();
  };

  const accountListCbk = item => {
    setSelectedList(item);
    setShowListDropdown(false);
  };

  const selectedListLabel = selectedList?.name || "No list selected";

  const dropdownHeaderChildren = selectedList ? (
    <>
      <div className="titleWrapper">
        <i className="material-icons-outlined customListIcon">
          format_list_bulleted
        </i>
        <div className="title">{selectedList.name}</div>
      </div>
      <div className="organizeSelectedListCount">
        <span className="organizeSelectedListCountNumber">
          {selectedList.count || 0}
        </span>
        <span className="organizeSelectedListCountLabel">Accounts</span>
      </div>
      <span className={`arrow ${showListDropdown ? "activeArrow" : ""}`}>
        <i className="material-icons">expand_more</i>
      </span>
    </>
  ) : null;

  const handleListCreated = () => {
    const newList = accountsState.accountLists.find(
      list => list.id === accountsState.activeAccountListId
    );
    if (newList) {
      setSelectedList(newList);
    }
  };

  useEffect(() => {
    if (organizeAccountsPopupState.showPopup) {
      setSelectedList(null);
      accountsState.fetchAccountLists();
    }
  }, [organizeAccountsPopupState.showPopup]);

  if (!organizeAccountsPopupState.showPopup) {
    return "";
  }

  return (
    <div className="popupWrapper tagPopup organizeAccountsPopup">
      {!showCreatePopup && (
        <>
          <div className="confirmation-popup common-popup">
            <div className="popup-wrap animated customzoomIn" autoComplete="off">
              <div className="tagPopupTitle">Organize Your Uploaded Accounts</div>
              <p className="tagPopupSubTitle">
                Add them to a list to keep everything structured.
              </p>
              <div
                className="popup-close"
                title="Click here to close"
                onClick={closeAction}
              >
                <i className="material-icons">close</i>
              </div>
              <div className="bodyCont">
                <div className="addTagSelectBox">
                  <div className="tagPopupRow">
                    <p className="addContactToListTitle">Add to List</p>
                    <div className="inputWrapper">
                      <section className="customListWrapper">
                        <div className="customListContainer">
                          <AutoCompleteDropdown
                            optionList={accountsState.accountLists}
                            defaultValue={selectedListLabel}
                            cbk={accountListCbk}
                            loader={false}
                            showIcon={true}
                            icon={
                              <i className="material-icons-outlined customListIcon">
                                format_list_bulleted
                              </i>
                            }
                            updateListBody={true}
                            Body={AccountListBody}
                            showDropdown={showListDropdown}
                            setShowDropdown={setShowListDropdown}
                            hasAddNewList={true}
                            HeaderChildren={dropdownHeaderChildren}
                          >
                            <CreateNewAccountList
                              setShowDropdown={setShowListDropdown}
                              setShowCreatePopup={setShowCreatePopup}
                            />
                          </AutoCompleteDropdown>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
                <TagPopupButtons
                  btnAction={confirmAction}
                  backAction={closeAction}
                  nextBtnEnabled={true}
                  btnText="Upload Accounts"
                />
              </div>
            </div>
          </div>
          <div className="common-popup-mask"></div>
        </>
      )}
      {showCreatePopup && (
        <CreateEditAccountListPopup
          mode="create"
          onClose={() => setShowCreatePopup(false)}
          onSaved={handleListCreated}
        />
      )}
    </div>
  );
});

export default OrganizeAccountsPopup;
export { OrganizeAccountsPopup, organizeAccountsPopupState };
